<template>
    <div style="background: #fff;">
        <el-table
                :data="tableData"
                :style="customStyle"
                :max-height="maxHeight||tableHeight"
                border
                width="100%"
                :size="size"
                :cell-style ="cellStyle"
                @row-dblclick="rowClick"
                @selection-change="handleSelectionChange"
        >
            <el-table-column
                    v-if="selectionShow||!tableUse.show"
                    type="selection"
                    align="center"
                    width="40">
            </el-table-column>
            <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    width="60">
                <template slot-scope="scope">
                    <span>{{(pageIndex-1)*pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    v-for="(tableCol,index) in tableSet.tableColumn"
                    :prop="tableCol.prop"
                    :label="tableCol.label"
                    :key="index"
                    :min-width="tableCol.width?tableCol.width+'px':(tableCol.label.length>10?'250px':'120px')"
                    show-overflow-tooltip
                    header-align="center"
                    :align="(tableCol.type=='tag'||tableCol.type=='tags'||tableCol.align=='center')?'center':'left'"
            >
                <!-- :width="(tableCol.type=='tag')&&130" -->
                <template slot-scope="scope">
                    <div v-if="tableCol.type=='button'" style="text-align:center;">
                        <el-button :type="tableCol.btnType"  plain size="mini" @click="onButton(scope.row)" slot="reference">{{tableCol.btnName?tableCol.btnName:scope.row[tableCol.prop]}}</el-button>
                    </div>
                    <div v-else-if="tableCol.type=='yjj'" style="text-align:center;">
                        <span>{{tableCol.method(scope.row[tableCol.targetKey])}}</span>
                    </div>
                    <div v-else-if="tableCol.type=='tag'">
                        <div v-for="(item,index) in tableCol.options" :key="index">
                            <el-tag :disable-transitions="true" v-if="item.value===scope.row[tableCol.prop]" :type="item.color">{{item.label}}</el-tag>
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='tags'">
                        <div v-for="(item,index) in tableCol.options" :key="index">
                            <el-tag :disable-transitions="true" v-if="item.value===scope.row[tableCol.prop]" :type="item.color">{{item.label}}</el-tag>
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='tagText'">
                        <el-tag :disable-transitions="true" :type="'primary'">{{scope.row[tableCol.prop]}}</el-tag>
                    </div>
                    <div v-else-if="tableCol.type=='filter'" >
                        <div v-for="(item,index) in tableCol.options" :key="index">
                            <span v-if="item.value===scope.row[tableCol.prop]">{{item.label}}</span>
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='iconClick'">
                        <div v-if="tableCol.options[0].title">
                            <div v-for="(item,index) in tableCol.options" :key="index" style="text-align:center;">
                                <el-tooltip :content="item.title" placement="right" effect="light">
                                    <i v-if="item.value===scope.row[tableCol.prop]" :class="'fa fa-'+item.icon" :style="'cursor:pointer;'+item.style" @click="tableCol.click(scope.row,tableCol.prop)"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="(item,index) in tableCol.options" :key="index" style="text-align:center;">
                                <i v-if="item.value===scope.row[tableCol.prop]" :class="'fa fa-'+item.icon" :style="'cursor:pointer;'+item.style" @click="tableCol.click(scope.row,tableCol.prop)"></i>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='icon'">
                        <div v-for="(item,index) in tableCol.options" :key="index" style="text-align:center;">
                            <i v-if="item.value===scope.row[tableCol.prop]" :class="'fa fa-'+item.icon" :style="'cursor:pointer;'+item.style" @click="onButton(scope.row)"></i>
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='stake'" :style="{ textAlign: typeof scope.row[tableCol.prop]=='number'?'right':'left'}">
                        {{scope.row[tableCol.prop] | stakeTableFilter }}
                    </div>
                    <div v-else-if="tableCol.type=='measure'" :style="{ textAlign: typeof scope.row[tableCol.prop]=='number'?'right':'left'}">
                        <div v-if="(scope.row[tableCol.measureUnit]&&(scope.row[tableCol.measureUnit].indexOf('/')>=0))">
                            {{scope.row[tableCol.prop] +" / "+ (scope.row[tableCol.propLabel]?scope.row[tableCol.propLabel]:0) }}</div>
                        <div v-else>
                            {{scope.row[tableCol.prop]}}
                        </div>
                        
                    </div>
                    <div v-else-if="tableCol.type=='chainLength'" :style="{ textAlign: typeof scope.row[tableCol.prop]=='number'?'right':'left'}">
                        {{scope.row[tableCol.prop] | chainLength }}
                    </div>
                    <div v-else-if="tableCol.type=='deviceTime'" :style="($getExpireTime(scope.row[tableCol.prop])>30)?'text-align:center':'color:red;text-align:center'">
                        {{scope.row[tableCol.prop] | dateFilter}}
                    </div>
                    <div v-else-if="tableCol.type=='dateFilter'" >
                        {{scope.row[tableCol.prop] | dateFilter}}
                    </div>
                    <div v-else-if="tableCol.type=='monthFilter'">
                        {{scope.row[tableCol.prop] | monthFilter}}
                    </div>
                    <div v-else-if="tableCol.type=='yearFilter'" >
                        {{scope.row[tableCol.prop] | yearFilter}}
                    </div>
                    <div v-else-if="tableCol.type=='inputNumber'" >
                        <div v-if="operationShow">
                            <el-input-number style="width:100%" @focus="focus($event)" :disabled="!operationShow" v-model="scope.row[tableCol.prop]"
                            :min="tableCol.min"
                            :max="tableCol.max"
                            :step="tableCol.step"
                            @change="numChange(scope.row[tableCol.prop],scope.$index,tableCol.prop)"
                            :precision="getPrecision(tableCol.step)" 
                            controls-position="right"></el-input-number>
                        </div>
                        <div v-else>
                            {{scope.row[tableCol.prop]}}
                        </div>
                    </div>
                    <div v-else-if="tableCol.type=='img'" >
                      <div v-if="(scope.row[tableCol.prop]!=null&&scope.row[tableCol.prop]!='')">
                      <div v-for="(item,index) in (scope.row[tableCol.prop].split(','))" :key="index" style="display:inline-block;text-align:center;">
                        <div v-if="!item">
                        </div>
                        <div v-else-if="(item.indexOf('http')>=0)">
                            <img :src="item" width="40" height="40"/>
                        </div>
                        <div v-else>
                            <img :src="ipPort+item" width="40" height="40"/>
                        </div>
                      </div>
                      </div>
                      <div v-else>暂无示例</div>
                    </div>
                    <div v-else :style="{ textAlign: typeof scope.row[tableCol.prop]=='number'?'right':'left'}"> {{scope.row[tableCol.prop]}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    :width="tableSet.colBtnWidth || 280"
                    v-if="operationShow">
                <template slot-scope="scope">
                    <el-button-group>
                        <div  v-if='tableUse.show'>
                            <el-button
                                    :size="tableUse.size"
                                    :type="tableUse.type"
                                    :plain="tableUse.planin"
                                    :round="tableUse.round"
                                    :circle="tableUse.circle"
                                    :loading="tableUse.loading"
                                    :disabled="tableUse.disabled"
                                    :icon="tableUse.icon"
                                    :title="tableUse.title"
                                    @click="tableUse.click(scope.row,scope.$index)">
                                <span v-if="tableUse.name!=''">{{tableUse.name}}</span>
                            </el-button>
                        </div>
                        <div v-else>
                            <div style="display:inline-block;"  v-for="(btn,index) in tableSet.tableColBtn" :key="index">
                                <div v-if="btn.show">
                                    <el-button
                                            v-if="btn.statusValue?(btn.statusValue.indexOf('/'+scope.row[auditStatus]+'/'))>=0:true"
                                            :size="btn.size"
                                            :type="btn.type"
                                            :plain="btn.planin"
                                            :round="btn.round"
                                            :circle="btn.circle"
                                            :loading="btn.loading"
                                            :disabled="btn.disabled"
                                            :icon="btn.icon"
                                            :title="btn.title"
                                            @click="btn.click(scope.row,scope.$index)">
                                        <span v-if="btn.name!=''">{{btn.name}}</span>
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <slot name="btn" :data="{row:scope.row,index:scope.$index}"></slot>
                    </el-button-group>
                </template>

            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                    background
                    v-if="pageShow"
                    :page-size="pageSize"
                    layout="total, prev, pager, next,jumper"
                    :current-page="pageIndex"
                    @current-change="goCurrentChange"
                    :total="pageCount">
            </el-pagination>
            <el-pagination
                    background
                    v-if="!pageShow&&pageShowX"
                    layout="total,prev, pager, next,sizes,jumper "
                    :current-page="pageIndex"
                    :page-sizes="[10, 15,20,50,100]"
                    @current-change="goCurrentChange"
                    @size-change="sizeChange"
                    :total="pageCount">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import { type } from 'os'
    export default {
        name: 'DynamicTable',
        data () {
            return {
                tableHeight:380,
                dialogTitle: '提示',
                showDialog: false,
                ipPort:"",
            }
        },
        props: {
            //表格自定义样式
            customStyle:{
                type:String,
                default: ()=> { return "width:100%" }
            },
            //表格最大高度
            maxHeight:{
                type:String,
                default: ()=> { return "" }
            },
            size:{
                type:String,
                default: ()=> { return "medium" }
            },
            //用于表格弹出的使用按钮
            tableUse:{
                type:Object,
                default:()=>{
                    return{
                        show:false,
                        size:"small",
                        type:"primary",
                        plain:true,
                        round:false,
                        circle:false,
                        loading:false,
                        disabled:false,
                        icon:"el-icon-finished",
                        title:"使用",
                        name:'使用'
                    }
                }
            },
            //表格的基本配置
            tableSet: {
                type: Object,
                default: () => {}
            },
            //表格的数据绑定
            tableData: {
                type: Array,
                default: () => []
            },
            //表格当前页
            pageIndex: {
                type: Number,
                default: 1
            },
            //表格当前页gesh
            pageSize: {
                type: Number,
                default: 10
            },
            //表格的数据总条数
            pageCount: {
                type: Number,
                default: 0
            },
            //操作栏不显示
            operationShow:{
                type:Boolean,
                default(){
                    return true;
                }
            },
            auditStatus:{
                type:String,
                default: ''
            },
            pageShow:{
                type:Boolean,
                default(){
                    return true;
                }
            },
            pageShowX:{
                type:Boolean,
                default(){
                    return false;
                }
            },
            //显示勾选
            selectionShow:{
                type:Boolean,
                default(){
                    return true
                }
            }
        },
        methods: {
            // 单元格样式
            cellStyle (row, column, rowIndex, columnIndex) {
                return 'padding:6px 0px'
            },
            // 行双击
            rowClick (row) {
                this.$emit('rowClick', row)
            },
            // 跳转页数
            goCurrentChange (val) {
                this.$emit('goPageIndex', val,this.pageSize)
            },
            //页数选择
            sizeChange(val){
                this.pageSize = val
                this.$emit('goPageIndex',this.pageIndex,val)
            },
            // 显示对话框
            onButton (val) {
                this.$emit('onButton', val)
            },
            //勾选
            handleSelectionChange(val){
                this.$emit('onSelection', val)
            },
            focus(event) {
                event.currentTarget.select();
            },
            getPrecision(val){
              if(val){
                var bb=val.toString().replace(/\d+\.(\d*)/,"$1");
                if(val.toString().indexOf(".")>0){
                  return bb.length
                }else{
                  return 0
                }
              }else{
                return 2
              }
            },
            numChange(val,index,model){
              let that = this
              if(!val){
                  this.tableData[index][model]=0;
              }
            },
        },
        //这段代码负责解决分页问题
        watch: {
          pageCount: {
              immediate: true,
              handler () {
                  if (this.pageSize * (this.pageIndex -1 ) > this.pageCount){
                      if (this.pageIndex === 1){
                          return
                      }
                      this.$emit('goPageIndex',this.pageIndex -1 ,this.pageSize)
                  }
              }
          }
        },
        created() {
            this.tableHeight = document.body.clientHeight - 300;
            this.$http.postX(this.$url.getDict, {
                search: "图片配置URL"
            }).then(res => {
                let { data } = res;
                this.ipPort=data[0].enCode;
            })
        }
    }
</script>
<style  scoped>
    .pagination {
        margin-top: 10px;
        text-align: left;
    }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Tables/DynamicTable.vue"
}
</vue-filename-injector>
